import React from "react";
import { Slide } from "react-awesome-reveal";
const Home = () => {
  return (
    <>
      <Slide triggerOnce><span className="name" >Max Campbell.</span>
      <span>
        <h2 >Builder ✓ Problem Solver ✓ Agile ✓</h2>
      </span>
      <span>
        I am a Frontend Developer that enjoys building web applications.  Always learning new technologies.
      </span></Slide>
    </>
  );
};

export default Home;
